import React from 'react'
import PartnerTabs from './PartnerTabs'
import ListPartner from './ListPartner'

const Partner = ({ activeTab, setActiveTab, partnerlist, totalCount, currentPage, totalPages, onPageChange }) => {
  return (
    <div className='pb-6'>
      <PartnerTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <ListPartner
        partnerlist={partnerlist}
        totalCount={totalCount}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  )
}

export default Partner
